import { useState } from 'react';
import { ICreateThemeData } from 'src/types';
import { IconMessageDots, IconX } from '@tabler/icons-react';
import { Translations } from 'src/translations/chatInputTranslations';
import getTextColor from '../../../hooks/getTextColorContrast';
import { getThemeColors } from './videoUtils';

interface VideoMessageBoxProps {
  isOpen: boolean;
  text: string | null;
  themeData: ICreateThemeData;
  onClose: () => void;
  hasMedia: boolean;
  t: Translations;
}

function VideoMessageBox({ isOpen, text, themeData, onClose, hasMedia, t }: VideoMessageBoxProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const isLongText = text && text.length > 220;
  const colors = getThemeColors(themeData);

  if (!isOpen || !text) {
    return null;
  }

  return (
    <div
      className="right-4 bg-white rounded-lg shadow-lg z-100 w-full max-w-md overflow-hidden"
      style={{
        backgroundColor: colors.primary,
      }}
    >
      <div className="p-2">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-2">
            <IconMessageDots
              size={20}
              style={{
                color: colors.chatPrimary,
              }}
            />
            <span
              className="font-semibold"
              style={{
                color: colors.chatPrimary,
              }}
            >
              {t.question}
            </span>
          </div>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded-full transition-colors"
            style={{
              backgroundColor: getTextColor(colors.primary),
            }}
            type="button"
          >
            <IconX
              size={12}
              style={{
                color: colors.primary,
              }}
            />
          </button>
        </div>
        <div>
          <p
            className={`text-sm leading-relaxed ${isLongText && !isExpanded ? 'line-clamp-4' : ''}`}
            style={{
              color: getTextColor(colors.primary),
            }}
          >
            {text}
          </p>
          {isLongText && (
            <div className="flex justify-end">
              <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="mt-2 text-xs underline transition-all font-bold"
                style={{
                  color: colors.chatPrimary,
                }}
                type="button"
              >
                {isExpanded ? t.showLess : t.showMore}
              </button>
            </div>
          )}
        </div>
      </div>
      {hasMedia && (
        <p
          className="text-xs mt-4 font-semibold text-center p-1"
          style={{
            color: getTextColor(colors.primary),
            backgroundColor: themeData?.['secondary-background'] || colors.chatPrimary,
          }}
        >
          ⚠️ {t.mediaWarning}
        </p>
      )}
    </div>
  );
}

export default VideoMessageBox;
